import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { recipesAPI } from '../../services/api';
import RecipeCard from '../common/RecipeCard';
import './Recipes.css';

export default function FollowingPage() {
  const [recipes, setRecipes] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const sentinel = useRef(null);

  const load = useCallback(async (pageNum, append) => {
    if (append) setLoadingMore(true); else setLoading(true);
    try {
      const data = await recipesAPI.getFollowingFeed({ page: pageNum, limit: 12 });
      setRecipes(prev => append ? [...prev, ...data.recipes] : data.recipes);
      setHasMore(pageNum < (data.pages || 1));
    } catch { /* ignore */ }
    if (append) setLoadingMore(false); else setLoading(false);
  }, []);

  useEffect(() => { load(1, false); }, [load]);

  useEffect(() => {
    if (page > 1) load(page, true);
    // eslint-disable-next-line
  }, [page]);

  useEffect(() => {
    const el = sentinel.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasMore && !loadingMore && !loading) {
          setPage(p => p + 1);
        }
      },
      { rootMargin: '200px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, loadingMore, loading]);

  if (loading) return <div className="loading-center"><div className="spinner" /></div>;

  return (
    <div className="recipes-page fade-in">
      <div className="page-header">
        <h1>Following Feed</h1>
        <p className="page-subtitle">Recipes from people you follow</p>
      </div>

      {recipes.length === 0 ? (
        <div className="empty-state">
          <span className="empty-icon">👀</span>
          <h3>No recipes yet</h3>
          <p>Start <Link to="/search">following other cooks</Link> to see their recipes here.</p>
        </div>
      ) : (
        <>
          <div className="recipe-grid">
            {recipes.map(r => <RecipeCard key={r._id} recipe={r} />)}
          </div>
          {loadingMore && (
            <div className="loading-center" style={{ padding: '20px 0' }}><div className="spinner" /></div>
          )}
          <div ref={sentinel} className="scroll-sentinel" />
        </>
      )}
    </div>
  );
}
